"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _StagedObject = _interopRequireDefault(require("redux-less/StagedObject"));

var _PropertyTypes = _interopRequireDefault(require("redux-less/constants/PropertyTypes"));

var _selectors = require("settings-ui-sdk/Blogs/selectors");

var _getBlogFromPayload = _interopRequireDefault(require("./getBlogFromPayload"));

var _actions = require("settings-ui-sdk/Blogs/actions");

var _constants = require("settings-ui-sdk/Blogs/constants");

var properties = [{
  type: _PropertyTypes.default.ORDERED_MAP,
  key: _constants.ATTACHED_STYLESHEETS
}, _constants.ALLOW_COMMENTS, _constants.AMP_BODY_COLOR, _constants.AMP_BODY_FONT_SIZE, _constants.AMP_BODY_FONT, _constants.AMP_HEADER_BACKGROUND_COLOR, _constants.AMP_HEADER_COLOR, _constants.AMP_HEADER_FONT_SIZE, _constants.AMP_HEADER_FONT, _constants.AMP_LINK_COLOR, _constants.AMP_LOGO_ALT, _constants.AMP_LOGO_HEIGHT, _constants.AMP_LOGO_SRC, _constants.AMP_LOGO_WIDTH, _constants.CLOSE_COMMENTS_OLDER, _constants.COMMENT_MAX_THREAD_DEPTH, _constants.COMMENT_MODERATION, _constants.COMMENT_NOTIFICATION_EMAILS, _constants.COMMENT_SHOULD_CREATE_CONTACT, _constants.COMMENT_VERIFICATION_TEXT, _constants.DESCRIPTION, _constants.DOMAIN, _constants.ENABLE_GOOGLE_AMP_OUTPUT, _constants.HTML_FOOTER_IS_SHARED, _constants.HTML_FOOTER, _constants.HTML_HEAD_IS_SHARED, _constants.HTML_HEAD, _constants.HTML_TITLE, _constants.ID, _constants.ITEM_LAYOUT_ID, _constants.ITEM_TEMPLATE_IS_SHARED, _constants.ITEM_TEMPLATE_PATH, _constants.LANGUAGE, _constants.LISTING_LAYOUT_ID, _constants.LISTING_TEMPLATE_PATH, _constants.MONTH_FILTER_FORMAT, _constants.NAME, _constants.POST_HTML_FOOTER, _constants.POST_HTML_HEAD, _constants.POSTS_PER_LISTING_PAGE, _constants.POSTS_PER_RSS_FEED, _constants.PUBLIC_ACCESS_RULES_ENABLED, _constants.PUBLIC_ACCESS_RULES, _constants.PUBLIC_TITLE, _constants.PUBLISH_DATE_FORMAT, _constants.SHOW_SOCIAL_LINK_FACEBOOK, _constants.SHOW_SOCIAL_LINK_LINKEDIN, _constants.SHOW_SOCIAL_LINK_TWITTER, _constants.SHOW_SUMMARY_IN_EMAILS, _constants.SHOW_SUMMARY_IN_LISTING, _constants.SHOW_SUMMARY_IN_RSS, _constants.SLUG, _constants.SOCIAL_ACCOUNT_TWITTER, _constants.USE_FEATURED_IMAGE_IN_SUMMARY];
var UpdateBlogSettings = new _StagedObject.default({
  stagedSelector: function stagedSelector(state) {
    return state.modules.website.blogs.staging.updateBlogGeneral;
  },
  domainSelector: _selectors.getBlogFromRoute,
  requestSuccessActionType: _actions.FetchBlogsActionTypes.SUCCESS,
  requestSuccessDataSelector: _getBlogFromPayload.default,
  namespace: 'blogs',
  objectType: _constants.BLOG + "/generalSettings",
  properties: properties
});
var _default = UpdateBlogSettings;
exports.default = _default;
module.exports = exports.default;